<script>
  import { onMount } from "svelte";
  import SelectedGender from "../stores/Persistent";

  $: val = $SelectedGender;

  function pushToStore() {
    SelectedGender.set(val);
  }

  const radio_group_name = "gender-" + crypto.randomUUID();

  const SHORT_TO_LONG_GENDER_STR = {
    m: "Dudes",
    f: "Chicks",
  };

  onMount(() => {
    const readVal = window.localStorage.getItem("name");
    if (readVal === null) {
      return;
    }
    SelectedGender.set(readVal);
  });
</script>

<div class="btn-group" role="group">
  {#each ["m", "f"] as g}
    <input
      type="radio"
      class="btn-check"
      name={radio_group_name}
      value={g}
      id={radio_group_name + g}
      autocomplete="off"
      bind:group={val}
      on:change={pushToStore}
    />
    <label class="btn btn-outline-danger" for={radio_group_name + g}
      >{SHORT_TO_LONG_GENDER_STR[g]} Mode</label
    >
  {/each}
</div>

<style>
</style>
